export const SCHEDULED_REPORTS_REPORT_ID = 'scheduled-reports';
